<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: quwandong
 * @LastEditTime: 2022-07-14 14:15:02
 * @FilePath: \motion\src\components\Bread.vue
-->
<template>
  <div class="bread">
    <div class="example-container">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item
          v-for="(item, index) in breads"
          :key="index"
          :to="{ path: item.path }"
        >
          <template v-if="index == 0">位置：</template>{{ item.meta.title
          }}<template v-if="item.path == '/finance/detail' && title">{{
            title
          }}</template>
          <template v-if="item.meta.showCustom">
            {{ $store.state.customBreadText }}
          </template>
        </el-breadcrumb-item>
        <!-- <el-breadcrumb-item v-if="title">{{title}}</el-breadcrumb-item> -->
      </el-breadcrumb>
    </div>
    <el-button
      v-if="breads[breads.length - 1].meta.hidden"
      @click="handleBack"
      type="primary"
      plain
      round
    >
      <i class="iconfont icon-fanhui"></i>返回
    </el-button>
  </div>
</template>
<script>
export default {
  props: ['title'],
  data() {
    return {
      breadList: [], // 路由集合
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    },
  },
  mounted() {},
  computed: {
    // 面包屑导航只显示设置了title属性的项
    breads() {
      return this.breadList.filter((item) => {
        return item.meta.title
      })
    },
  },
  methods: {
    isHome(route) {
      return route.name === 'Home'
    },
    getBreadcrumb() {
      let matched = this.$route.matched
      // if (!this.isHome(matched[0])) {
      //   matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
      // }
      this.breadList = matched
    },
    /**
     * @descripttion: 返回
     * @Author: juanjuanhui
     * @Date: 2021-12-11 21:57:04
     */
    handleBack() {
      this.$router.go(-1)
    },
  },
  created() {
    this.getBreadcrumb()
  },
}
</script>
<style lang="scss" scoped>
.bread {
  display: flex;
  justify-content: space-between;
  align-items: center;
  ::v-deep .el-breadcrumb {
    display: inline-block;
    height: 56px;
    vertical-align: top;
    line-height: 56px;
    .el-breadcrumb__item {
      font-size: 16px;
      color: #2f2f2f;
      &:first-child {
        font-size: 16px;
        color: #2f2f2f;
      }
    }
  }
  ::v-deep .is-link {
    font-weight: normal;
  }
  .el-button {
    width: 78px;
    height: 34px;
    padding: 0;
    border-radius: 17px;
    background-color: #ebf5f6;
    &:hover {
      background-color: #018388;
    }
    .iconfont {
      margin-right: 5px;
    }
  }
}
</style>
